import React from 'react'
import { Pagination } from '@mantine/core';

const Paginator = ({ onPageClick, pageCount, pageRangeDisplayed, marginPagesDisplayed, activePage, marginTop = 25 }) => {
  return (
    <>
      <Pagination value={activePage} onChange={onPageClick} total={pageCount} mt={marginTop} mb={25} />
    </>
  )
}

export default Paginator;